import React from 'react';
import './DoorbaseTile.css';

export function DoorbaseTile({ icon, label, description, badge, onClick }) {
  return (
    <button type="button" className="doorbase-tile" onClick={onClick}>
      {badge ? <span className="doorbase-tile-badge">{badge}</span> : null}
      <span className="doorbase-tile-icon" aria-hidden="true">{icon}</span>
      <span className="doorbase-tile-label">{label}</span>
      {description ? <span className="doorbase-tile-desc">{description}</span> : null}
    </button>
  );
}

export function DoorbaseTileGrid({ children, columns = 2 }) {
  const count = Math.max(1, Number(columns) || 2);
  return (
    <div
      className="doorbase-tile-grid"
      style={{ gridTemplateColumns: `repeat(${count}, minmax(2cm, 1fr))` }}
    >
      {children}
    </div>
  );
}

export default DoorbaseTile;
